import { useEffect, useState } from "react";
import styled from "styled-components";
import { BellIcon, PenIcon } from "ui/icons";
import { convertHexToRGBA, defaultThemeColors, fonts, mediaSizes } from "ui/theme/index.js";
import { EditProfile } from "./section/editProfile/EditProfil";
import { NotificationSection } from "./section/notification/notification";

export const Settings = () => {

    const [activeTab, setActiveTab] = useState(null);

    useEffect(() => {
        const defaultValue =
            window.innerWidth >= +mediaSizes.md.replace('px', '')
                ? "editProfile"
                : null
        setActiveTab(defaultValue);
    }, []);

    const setTabToNull = () => setActiveTab(null)
    return (
        <Container>
            <Sidebar isTabActive={!!activeTab}>
                <Title>Settings</Title>
                <SidebarItem
                    active={activeTab === "editProfile"}
                    onClick={() => setActiveTab("editProfile")}
                >
                    <PenIcon /> Edit profile
                </SidebarItem>
                <SidebarItem
                    active={activeTab === "notifications"}
                    onClick={() => setActiveTab("notifications")}
                >
                    <BellIcon /> Notifications
                </SidebarItem>
            </Sidebar>

            <Content>
                <SidebarContent active={activeTab === "editProfile"}>
                    <EditProfile setTabToNull={setTabToNull} />
                </SidebarContent>
                <SidebarContent active={activeTab === "notifications"}>
                    <NotificationSection setTabToNull={setTabToNull} />
                </SidebarContent>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    max-width: 1300px;
    margin-inline: auto;
    padding-block: 2rem;
    padding-inline: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    font-family: var(--font-secondary);
    margin-bottom: 4rem;
    min-height: var(--page-height);

    @media (width >= ${mediaSizes.md}) {
        flex-direction: row;
        gap: 2rem;
        height: var(--page-height);
        padding-block: 3.5rem;
        padding-inline: 2rem;
    }
    @media (width >= ${mediaSizes.lg}) {
        height: var(--page-height);
        gap: 4rem;
    }
`;

const Sidebar = styled.div`
    flex-direction: column;
    gap: 1rem;
    min-width: 200px;
    display: ${({ isTabActive }) => (isTabActive ? "none" : "flex")};
    @media (width >= ${mediaSizes.md}) {
        display: flex;
    }
`;

const Title = styled.h1`
    font-size: ${fonts.sizes.big};
    font-weight: 600;

    @media (width >= ${mediaSizes.md}) {
        font-size: ${fonts.sizes.h4};
    }
    @media (width >= ${mediaSizes.lg}) {
        font-size: ${fonts.sizes["h3.4"]};
    }
`;

const SidebarItem = styled.button`
    background: ${({ active }) =>
        active ? convertHexToRGBA(defaultThemeColors.blue, 0.05) : "none"};
    color: ${({ active }) =>
        active ? defaultThemeColors.blue : defaultThemeColors.txt};
    border: none;
    padding: 1rem;
    text-align: left;
    cursor: pointer;
    border-radius: 8px;
    font-family: Montserrat;
    font-size: ${fonts.sizes.regular};
    font-weight: 600;

    &:hover {
        background-color: ${convertHexToRGBA(defaultThemeColors.blue, 0.05)};
        color: ${defaultThemeColors.blue};
    }

    display: flex;
    align-items: center;
    gap: 1rem;

    & svg {
        width: 20px;
        height: 20px;
        opacity: 0.8;
    }
`;

const Content = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    @media (width >= ${mediaSizes.md}) {
        border-left-width: 2px;
        border-left-color: ${defaultThemeColors.lightBlue};
        border-left-style: solid;
    }
`;

const SidebarContent = styled.div`
    display: ${({ active }) => (active ? "flex" : "none")};
    flex-grow: 1;
    height: 100%;
    flex-direction: column;
    width: 100%;
`;



